import { resolveToastMessage, useI18n } from '@nx/i18n';
import { EOIcon } from './EOIcon';

export interface EOToastItem {
  id: string;
  msg: string;
  kind?: '' | 'danger' | 'success';
  params?: Record<string, string>;
}

export interface EOToastHostProps {
  toasts: EOToastItem[];
}

export function EOToastHost({ toasts }: EOToastHostProps) {
  const { t } = useI18n();

  return (
    <div className="toast-wrap" aria-live="polite">
      {toasts.map((toast) => (
        <div key={toast.id} className={`toast ${toast.kind ?? ''}`.trim()}>
          <EOIcon n={toast.kind === 'danger' ? 'alert' : 'check'} size={16} />
          <span>{resolveToastMessage(t, toast.msg, toast.params)}</span>
        </div>
      ))}
    </div>
  );
}
